export const conceptGroupsMessagesEn = {
  // Breadcrumbs
  'conceptGroups.breadcrumbs.conceptGroups': 'Concept groups',

  // Page Title
  'conceptGroups.pageTitle': 'Concept groups',

  // Column Headers
  'conceptGroups.columns.omopConceptGroupId': 'OMOP concept group ID',
  'conceptGroups.columns.conceptGroupName': 'Name',
  'conceptGroups.columns.domains': 'Domains',
  'conceptGroups.columns.conceptCount': 'Concept count',
  'conceptGroups.columns.owner': 'Owner',
  'conceptGroups.columns.modifiedDate': 'Modified on',

  // Actions
  'conceptGroups.actions.createConceptGroup': 'Create concept group',
  'conceptGroups.actions.deleteConceptGroup': 'Delete concept group',
  'conceptGroups.actions.renameConceptGroup': 'Rename concept group',

  // Rename dialog, opened from a concept-group row on the project artifact list.
  // TODO: cleanup with concept_group_rename ff
  'conceptGroups.renameConceptGroupModal.title': 'Rename concept group',
  'conceptGroups.renameConceptGroupModal.nameLabel': 'Concept group name',
  'conceptGroups.renameConceptGroupModal.cancelButton': 'Cancel',
  'conceptGroups.renameConceptGroupModal.saveButton': 'Save',
  'conceptGroups.renameConceptGroupModal.saving': 'Saving…',
  'conceptGroups.renameConceptGroupModal.duplicateName':
    'A concept group with this name already exists. Choose a different name.',
  'conceptGroups.renameConceptGroupModal.conflict':
    'This draft changed since the list loaded. Refresh, then rename it again.',
  'conceptGroups.renameConceptGroupModal.error':
    'Couldn’t rename the concept group. Please try again.',

  // Validation Results
  'conceptGroups.validationResults.groupName': 'Concept group:',
  'conceptGroups.validationResults.conceptsFound': 'Concepts found:',
  'conceptGroups.validationResults.conceptsNotFound': 'Concepts not found:',
  'conceptGroups.validationResults.saveInfo':
    'Once created, this concept group will be saved for use across all projects.',
  'conceptGroups.validationResults.standardConcepts': 'Standard concepts:',
  'conceptGroups.validationResults.nonStandardConcepts': 'Non-standard concepts:',
  'conceptGroups.validationResults.columns.standard': 'Standard',
  'conceptGroups.validationResults.standardConceptTooltip':
    'Standard concepts appear in recommended concept fields and follow OMOP vocabulary standards. Non-standard concepts only populate source concept fields and are intended for data exploration rather than analysis.',
  'conceptGroups.validationResults.yes': 'Yes',
  'conceptGroups.validationResults.no': 'No',

  // Validation Results: DataGrid column headers
  'conceptGroups.validationResults.columns.omopConceptId': 'OMOP concept ID',
  'conceptGroups.validationResults.columns.conceptName': 'Concept name',
  'conceptGroups.validationResults.columns.vocabulary': 'Vocabulary',
  'conceptGroups.validationResults.columns.conceptCode': 'Concept code',
  'conceptGroups.validationResults.columns.domain': 'Domain',

  // Dialog
  'conceptGroup.dialog.title': 'Create concept group',
  'conceptGroup.dialog.cancel': 'Cancel',
  'conceptGroup.dialog.back': 'Back',
  // Create-modal error step: recover from a failed upload by swapping the file.
  'conceptGroup.dialog.chooseDifferentFile': 'Choose a different file',
  'conceptGroup.dialog.downloadTemplate': 'Download template',
  'conceptGroup.dialog.upload': 'Upload',
  'conceptGroup.steps.upload': 'Upload',
  'conceptGroup.steps.review': 'Review',
  'conceptGroup.validationResults.title': 'Concept group validation results',
  'conceptGroup.validationResults.conceptGroupName': 'Concept group:',
  'conceptGroup.validationResults.conceptsFound': 'Concepts found',
  'conceptGroup.validationResults.conceptsNotFound': 'Concepts not found',
  'conceptGroup.fileUpload.selectedFile': 'Selected file',
  'conceptGroup.fileUpload.uploadFile': 'Upload file',
  'conceptGroup.fileUpload.dragDrop': 'Drag & drop your spreadsheet',
  'conceptGroup.fileUpload.orClick': 'or, click to browse',
  'conceptGroup.fileUpload.maxSize': '4 MB max  |  Supported formats: .csv, .xlsx, .xls',
  'conceptGroup.fileUpload.errorTitle': 'Error',
  'conceptGroup.fileUpload.errorSize': 'File size exceeds the 4MB limit',
  'conceptGroup.fileUpload.errorFormat': 'Unsupported file format. Please use .xlsx, .xls, or .csv',
  // Shown on the draft's source-file bar when a "Change file" replace upload
  // fails — the previous file stays; the user can pick a different one.
  'conceptGroup.fileUpload.errorReplace':
    "Couldn't replace the file — it may be invalid or unreadable. Try a different file.",
  'conceptGroup.instructions.title': 'Upload files',
  'conceptGroup.instructions.description':
    'Create a concept group by uploading a list of OMOP standard concept IDs. A template is available for download to ensure proper formatting and structure. After uploading the file, a preview of the concept group will be available for review.',
  'conceptGroup.nameInput.label': 'Concept group name',
  'conceptGroup.nameInput.placeholder': 'Enter concept group name',
  'conceptGroup.nameInput.error': 'Error occurred while validating concept group name.',
  'conceptGroups.validationResults.notFound': 'Not found',
  'conceptGroup.nameInput.nameExists': 'Concept group with the given name already exist.',
  'conceptGroup.error.title': 'Error',
  'conceptGroup.error.uploadTooLarge':
    'File is too large for the system to process. Please reduce the file size and try again.',
  'conceptGroup.error.uploadError':
    'File could not be uploaded due to a system error. You can retry uploading the spreadsheet by selecting the action below.',
  'conceptGroup.error.createError':
    'Concept group could not be created due to a system error. You can retry creating the concept group by selecting the action below.',
  'conceptGroup.dialog.success.title': 'Success',
  'conceptGroup.dialog.success.text': '"{conceptGroupName}" concept group created successfully',

  // Preview: previously created groups
  'conceptGroups.preview.previouslyCreated': 'Concept groups previously created from this preview:',

  // Concept Group Details Dialog
  'conceptGroup.details.domains': 'Domain(s):',
  'conceptGroup.details.ownedBy': 'Owner:',
  'conceptGroup.details.lastModified': 'Last Modified:',
  'conceptGroup.details.omopConceptId': 'OMOP concept ID',
  'conceptGroup.details.conceptName': 'Concept name',
  'conceptGroup.details.vocabulary': 'Vocabulary',
  'conceptGroup.details.conceptCode': 'Concept code',
  'conceptGroup.details.domain': 'Domain',

  // Concept Group Prevalence Panel (concept_group_prevalence_preview ff)
  'conceptGroup.prevalence.title': 'Prevalence',
  'conceptGroup.prevalence.dataset': 'Dataset:',
  'conceptGroup.prevalence.totalPatients': '{count, number} patients',
  'conceptGroup.prevalence.patientsCount':
    '{count, number} {count, plural, one {patient} other {patients}}',
  'conceptGroup.prevalence.eventsCount':
    '{count, number} {count, plural, one {event} other {events}}',
  'conceptGroup.prevalence.errorTitle': 'Prevalence unavailable',
  'conceptGroup.prevalence.errorBody':
    'Could not compute prevalence for dataset {datasetLabel}. Try again or pick a different dataset.',
  'conceptGroup.prevalence.noDomains': 'No supported OMOP domains found in this concept group.',

  // Delete Concept Group Modal
  'conceptGroups.deleteConceptGroupModal.title': 'Delete concept group',
  'conceptGroups.deleteConceptGroupModal.inUseTitle': 'Concept group in use',
  'conceptGroups.deleteConceptGroupModal.confirmTitle': 'Confirm delete',
  'conceptGroups.deleteConceptGroupModal.description':
    'This action will permanently delete {conceptGroupName}.',
  'conceptGroups.deleteConceptGroupModal.actionUndone': 'This action cannot be undone.',
  'conceptGroups.deleteConceptGroupModal.inUseError': 'Cannot delete concept group',
  'conceptGroups.deleteConceptGroupModal.inUseDescription':
    'This concept group cannot be deleted because it is currently used in a cohort definition. To delete it, first remove it from all cohort definitions.',
  'conceptGroups.deleteConceptGroupModal.cancelButton': 'Cancel',
  'conceptGroups.deleteConceptGroupModal.deleteButton': 'Delete concept group',
  'conceptGroups.deleteConceptGroupModal.submitting': 'Deleting concept group',
  'conceptGroups.deleteConceptGroupModal.closeButton': 'Close',
  'conceptGroups.deleteConceptGroupModal.submittingError': 'Error',
  'conceptGroups.deleteConceptGroupModal.success.title': 'Concept group deleted',
  'conceptGroups.deleteConceptGroupModal.success.text':
    '"{conceptGroupName}" was deleted successfully.',

  // Bulk workbook export (OR-6580). Rendered by the project page's artifact list.
  'conceptGroups.export.inProgress': 'Export in progress',
  'conceptGroups.export.modalTitle': 'Export concept groups',
  'conceptGroups.export.loadingTitle': 'Preparing export',
  'conceptGroups.export.loadingText':
    "We're building your Excel file. You can close this window and it will continue in the background.",
  'conceptGroups.export.errorTitle': 'Export failed',
  'conceptGroups.export.errorText': "We couldn't build the concept group file. Please try again.",
  'conceptGroups.export.retry': 'Retry',
  // `N selected` until the cap is hit, then against the whole listed set — the only
  // notice the user gets that the remaining rows went inert.
  'conceptGroups.export.pillCount': '{count} selected',
  'conceptGroups.export.selectionCount': '{count} of {total} selected',
  'conceptGroups.export.selectionClear': 'Clear',
  'conceptGroups.export.selectionSubmit': 'Export',
  // `Ready` is the asset-status name the row's own chip shows.
  'conceptGroups.export.rowNotReady': 'Only Ready concept groups can be exported',
  'conceptGroups.export.selectionLimitReached':
    'Export supports up to {max} concept groups at a time. Deselect one to choose another.',
};

export default conceptGroupsMessagesEn;
